export default "__VITE_ASSET__Bp43h9ne__"